import { render, staticRenderFns } from "./CopyHtml.vue?vue&type=template&id=2a162f84&scoped=true&"
import script from "./CopyHtml.vue?vue&type=script&lang=js&"
export * from "./CopyHtml.vue?vue&type=script&lang=js&"
import style0 from "./CopyHtml.vue?vue&type=style&index=0&id=2a162f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a162f84",
  null
  
)

export default component.exports